module.exports = __webpack_public_path__ + "static/media/logo.9383b3d9.png";